<template>
  <div class="container-fluid margin-9apuap">
    <div class="container-width">

      <div class="row without_sliders no-gutters">
        <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="getTeaser()" :position="1"></teaser4>
        <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="getTeaser()" :position="2"></teaser4>
        <teaser4 v-if="isTable() || teasers.length === 3" style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="getTeaser()" :position="3"></teaser4>
      </div>
        
      <div class="row without_sliders no-gutters" v-if="isTable()">
        <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="getTeaser()" :position="4"></teaser4>
        <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="getTeaser()" :position="5"></teaser4>
        <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="getTeaser()" :position="6"></teaser4>
      </div>



        <infinite :offset="teaserOffset" v-if="teaserOffset > 0" type-content="0"></infinite>

    </div>

    <pixel></pixel>
  </div>



</template>

<script>

    import NewsTeaser from '../components/news-teaser'
    import teaser4 from '../components/teaser4'
    import NewsTeaser2 from '../components/news-teaser2'
    import NewsTeaser3 from '../components/news-teaser3'
    // import NewsTeaserTransparent from '../components/news-teaser-transparent'
    // import NewsTeaserRetractable from '../components/news-teaser-retractable'
    import infinite from '@/components/infinite-preview2.vue'
    import pixel from '../components/pixel'
    window.pinter = 0;

    export default {
        name: 'home',
        components: {
            NewsTeaser,
            NewsTeaser2,
            NewsTeaser3,
            teaser4,
            // NewsTeaserTransparent,
            // NewsTeaserRetractable,
            infinite,
            pixel,
        },
        props: {
            rubric_id: {
                type: Number,
                default: 0
            },
        },
        data(){
            return {
                teasers:[],
                infiniteOffset:0,
                teaserOffset:0,
           
            }
        },
        mounted(){
            this.onFetch();





        },
        methods:{
          onFetch(){
            this.teasers = [];

              let amount = (this.isTable()) ? 6 : 3;


            this.Helper.getTeasers(this, amount, this.teaserOffset, 1, 0, {quality:1, type_content:0})
                    .onSuccess((response)=>{
                      this.teasers = response.data;
                      this.teaserOffset = response.data.length;

                    })
                    .onFail((error)=>{
                      console.log(error)
                    })
          },

          getTeaser () {
                return this.Helper.getOneTeaser(this.teasers);
            },
 			getTeasers (amount) {
                return this.Helper.getManyTeaser(this.teasers, amount);
            },
        },
        computed:{



        },
        watch:{
            '$route.params.rubricId'(){
                this.onFetch();
                this.infiniteOffset = 0;
            },
        },
    }
</script>